import styles from "./SystemFooter.module.css";

interface SystemFooterProps {
  className?: string;
  year?: number;
}

export function SystemFooter({
  className,
  year = new Date().getFullYear(),
}: SystemFooterProps) {
  return (
    <p className={[styles.footer, className].filter(Boolean).join(" ")}>
      © {year} MES System. All rights reserved.
    </p>
  );
}
